import React, { useState } from "react";
import axios from "axios";
import {
  Card,
  Row,
  CardBody,
  Col,
  FormGroup,
  Label,
  FormText,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Alert,
  Form,
} from "reactstrap";
import { getCookie } from "../../jwt/_helpers/cookie";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const OrderTokens = () => {
  const token = getCookie("token");
  const { t } = useTranslation();

  const tokenAmounts = [25, 50, 75, 100, 150, 200, 250, 300, 400, 500];
  const tokensAmountOps = tokenAmounts.map((amount) => ({
    label: t("tokens.order.form.option.tokensAmount", { count: amount }),
    value: amount,
  }));

  const options = {
    method: "POST",
    mode: "cors",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-api-key": X_API_KEY,
      "Content-Type": "application/json",
    },
  };

  const [openModal, setToggleModal] = useState(false);
  const [errorPut, setError] = useState(false);
  const [checkoutLink, setCheckoutLink] = useState("");
  const [sessionId, setSessionId] = useState("");

  const [tokensAmountTab, setTokensAmountTab] = useState({
    label: "",
    value: "",
  });

  const validateFields = () => {
    let validationErrors = 0;
    if (tokensAmountTab.value === "") {
      document.getElementById("err_tokens_quantity").style.display = "block";
      validationErrors = validationErrors + 1;
    }
    return validationErrors;
  };

  const handleSubmit = () => {
    const validationErrors = validateFields();

    if (validationErrors !== 0) {
      return false;
    } else {
      let orderData = {
        quantity: tokensAmountTab.value,
      };

      axios
        .post(`${API_URL}create-token-checkout-session/`, orderData, options)
        .then(function (response) {
          if (response.status === 200) {
            let responseData = response.data;
            if (responseData.url) {
              setCheckoutLink(responseData.url);
              setSessionId(responseData.session_id);
              setToggleModal(true);
            }
          } else {
            setError(true);
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 400) {
              let errorData = error.response.data;
              if (errorData.error) {
                setError(true);
              }
            }
          } else if (error.request) {
            setError(true);
          } else {
            setError(true);
          }
        });
    }
  };

  return (
    <div>
      <Row>
        <Col sm={12}>
          <Card>
            <CardBody>
              <h3>{t("tokens.order.title")}</h3>

              <Form id="orderTokensForm">
                <FormGroup>
                  <Label>{t("tokens.order.form.label.quantity")}</Label>
                  <Select
                    components={{ IndicatorSeparator: () => null }}
                    closeMenuOnSelect={true}
                    className="artistType"
                    name="quantity"
                    options={tokensAmountOps}
                    value={tokensAmountTab.value === "" ? null : tokensAmountTab}
                    placeholder={t("tokens.order.form.placeholder.quantity")}
                    onChange={(e) => {
                      document.getElementById(
                        "err_tokens_quantity"
                      ).style.display = "none";
                      setTokensAmountTab(e);
                    }}
                  />
                  <FormText color="muted">
                    {t("tokens.order.form.help.quantity")}
                  </FormText>
                  <div
                    style={{ width: "100%", display: "flex", marginTop: "5px" }}
                  >
                    <div
                      className="fv-help-block"
                      style={{ display: "none" }}
                      id={"err_tokens_quantity"}
                    >
                      {t("tokens.order.form.validation.quantityRequired")}
                    </div>
                  </div>
                </FormGroup>

                <Button
                  className="btn btn-outline-success pull-right"
                  color="success"
                  onClick={handleSubmit}
                >
                  {t("tokens.order.form.button.placeOrder")}
                </Button>
              </Form>

              <div style={{ paddingTop: "24px" }}>
                {errorPut && (
                  <Alert color="danger">
                    {t("tokens.order.message.error")}
                  </Alert>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {openModal && (
        <Modal isOpen={openModal} centered={true}>
          <ModalHeader>{t("tokens.order.modal.title")}</ModalHeader>
          <ModalBody>
            {t("tokens.order.modal.orderedPrefix")}{" "}
            <b>{t("tokens.order.form.option.tokensAmount", { count: tokensAmountTab.value })}</b>
            <br /><br />
            {t("tokens.order.modal.description")}
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                axios.post(
                  `${API_URL}expire-checkout-session/`,
                  { session_id: sessionId },
                  options
                );
                setToggleModal(false);
              }}
            >
              {t("tokens.order.modal.button.cancel")}
            </Button>
            <a
              href={`${checkoutLink}`}
              className="btn btn-md btn-success"
              rel="noopener noreferrer"
            >
              {t("tokens.order.modal.button.checkout")}
            </a>
          </ModalFooter>
        </Modal>
      )}
    </div>
  );
};

export default OrderTokens;
